import { render, staticRenderFns } from "./CameraAndMeasureSettings.vue?vue&type=template&id=20ab1caa&scoped=true&"
import script from "./CameraAndMeasureSettings.vue?vue&type=script&lang=ts&"
export * from "./CameraAndMeasureSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CameraAndMeasureSettings.vue?vue&type=style&index=0&id=20ab1caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ab1caa",
  null
  
)

export default component.exports